import "./styles.scss"

export const ImageRounded = ({ icon, className }) => {

  return (
    <div className={`image-rounded ${className ? className : ""}`}>
      <img src={icon} style={icon && {backgroundColor: 'transparent !important'}}/>
    </div>
  )
}
